import { AlertTitle, List, ListItem } from "@mui/material";

const ValidationErrorDetails = ({ error }) => {
    const formattedErrors = error?.details?.errors
        ? Object.entries(error.details.errors).flatMap(([key, messages]) =>
            messages.map((message) => ({ key, message }))
        )
        : [];

    return (
        <div>
            <AlertTitle>{error.details?.title || error.title}</AlertTitle>
            <List>
                {formattedErrors.length > 0 ? (
                    formattedErrors.map((error, index) => (
                        <ListItem key={index}>
                            <ul>
                                {error.message && (
                                    <li>
                                        {error.message}
                                        {error.key && ` (${error.key})`}
                                    </li>
                                )}
                            </ul>
                        </ListItem>
                    ))
                ) : (
                    <ListItem>
                        <p>{error.message + ` ` + error.defaultMessage || "An unknown error occurred."}</p>
                    </ListItem>
                )}
            </List>
        </div>
    );
};

export default ValidationErrorDetails;